import {useMutation, useQueryClient} from '@tanstack/react-query';
import IntegrationConfigService from 'src/services/integration-config-service';
import {integrationConfigKeys} from './queries';
import {IntegrationConfig, IntegrationConfigCreateInput} from 'src/core/data/api/IntegrationConfig';

export const useCreateIntegrationConfig = () => {
  const queryClient = useQueryClient();
  const integrationConfigService = new IntegrationConfigService();

  return useMutation({
    mutationFn: (data: IntegrationConfigCreateInput) => integrationConfigService.save(data),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationConfigKeys.all});
    },
  });
};

export const useUpdateIntegrationConfig = () => {
  const queryClient = useQueryClient();
  const integrationConfigService = new IntegrationConfigService();

  return useMutation({
    mutationFn: (data: IntegrationConfig) => integrationConfigService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationConfigKeys.all});
    },
  });
};

export const useDeleteIntegrationConfig = () => {
  const queryClient = useQueryClient();
  const integrationConfigService = new IntegrationConfigService();

  return useMutation({
    mutationFn: (id: number) => integrationConfigService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: integrationConfigKeys.all});
    },
  });
};
